/**
 * Talkvit API — Reusable Axios instance and configuration for Talkvit services.
 * Can be consumed by any module (WhatsApp, or future integrations).
 */
import axios from "axios";
import { decodeTalkvitUserToken } from "../helpers/decodeTalkvitUserToken";

// ─── Environment Variables ───────────────────────────────────────

const TALKVIT_SERVER_URL =
  process.env["REACT_APP_WHATSAPP_SERVER_URL"] ??
  "https://banqapinewtest.banquetfirst.com";

const TALKVIT_API_KEY = process.env["REACT_APP_WHATSAPP_API_KEY"] || "";
const TALKVIT_S3_URL = process.env["REACT_APP_WHATSAPP_S3_URL"] || "";
const GOOGLE_MAP_API_KEY = process.env["REACT_APP_GOOGLE_MAP_API_KEY"] || "";

// ─── Frozen Config (immutable at runtime) ────────────────────────

export const talkvitConfig = Object.freeze({
  baseUrl: `${TALKVIT_SERVER_URL}/api/v1`,
  socketUrl: TALKVIT_SERVER_URL,
  apiKey: TALKVIT_API_KEY,
  s3BaseUrl: TALKVIT_S3_URL,
  googleMapsApiKey: GOOGLE_MAP_API_KEY,
});

// ─── Decoded Token (user info from the API key JWT) ──────────────

export interface ITalkvitUser {
  company_outlet_uuid: string;
  company_outlet_timezone: string;
  full_name: string;
  user_uuid: string;
  role_uuid: string;
  role_value: string;
  iat: number;
}

export const talkvitUser: ITalkvitUser = TALKVIT_API_KEY
  ? decodeTalkvitUserToken(TALKVIT_API_KEY)
  : {
      company_outlet_uuid: "",
      company_outlet_timezone: "",
      full_name: "",
      user_uuid: "",
      role_uuid: "",
      role_value: "",
      iat: 0,
    };

// ─── Axios Instance ──────────────────────────────────────────────

export const talkvitApi = axios.create({
  baseURL: talkvitConfig.baseUrl,
});

// Attach auth token interceptor
talkvitApi.interceptors.request.use((config) => {
  if (talkvitConfig.apiKey && config.headers) {
    config.headers["auth-Token"] = talkvitConfig.apiKey;
  }
  return config;
});
